//acción para iniciar una sesion de usuario
export const startSession = (dispatch, firebase, email, password) => {
  return new Promise((resolve, reject) => {
    firebase.auth
      .signInWithEmailAndPassword(email, password)
      .then(auth => {
        //auth.user.uid - id del usuario autenticado en la base de datos
        firebase.db
          .collection("Users")
          .doc(auth.user.uid)
          .get()
          .then(doc => {
            const userDB = doc.data();
            //console.log(userDB);
            //el dispatch llama al reducer correspondiente
            dispatch({
              type: "START_SESSION",
              sesion: userDB,
              signin: true
            });
            //hay que poner el resolve para que se pare la ejecucion de la consulta una vez resuelta
            resolve({ status: true });
          });
      })
      .catch(error => {
        console.log("Se ha producido un error al iniciar sesion", error);
        resolve({ status: false, message: error });
      });
  });
};
//accion para crear un usuario, esto es, para registrar un usuario en la bbdd
export const createUser = (dispatch, firebase, usuario) => {
  return new Promise((resolve, reject) => {
    firebase.auth
      .createUserWithEmailAndPassword(usuario.email, usuario.password)
      .then(auth => {
        firebase.db
          .collection("Users")
          .doc(auth.user.uid)
          //indica los valores que se van a ingresar para este usuario
          .set(
            {
              id: auth.user.uid,
              email: usuario.email,
              name: usuario.name,
              surname: usuario.surname
            },
            { merge: true }
          )
          .then(doc => {
            //este doc no tiene data json
            //hay que indicar cual es el id del usuario creado
            //id del usuario creado
            usuario.id = auth.user.uid;
            dispatch({
              type: "START_SESSION",
              sesion: usuario,
              signin: true
            });
            //hay que poner el resolve para que se pare la ejecucion de la consulta una vez resuelta
            resolve({ status: true });
          });
      })
      .catch(error => {
        console.log("Se ha producido un error al registrar el usuario", error);
        resolve({ status: false, message: error });
      });
  });
};
//accion para cerrar la sesion de usuario
export const exitSession = (dispatch, firebase) => {
  return new Promise((resolve, reject) => {
    firebase.auth
    .signOut()
    .then(success => {
      dispatch({
        type: "CLOSE_SESSION",
        newuser: {
          name: "",
          surname: "",
          email: "",
          photo: "",
          id: "",
          phone: ""
        },
        signin: false
      })
        //hay que poner el resolve para que se pare la ejecucion de la consulta una vez resuelta
        resolve();
      })
      .catch(error => {
        console.log("error", error);
      });
  });
};
